<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container fluid>
            <div class="d-flex mb-4">
                <h2>{{$t('Saved Primary Geofence')}}</h2>
                <v-spacer></v-spacer>
            </div>
            <v-card
                elevation="0"
                class="px-5"
                min-height="500"
            >
                <v-card-text>
                     <v-row class="fill-height black--text" no-gutters>
                        <v-col cols="3" class="pa-2">
                        </v-col>
                        <v-col cols="9">
                            <v-container fill-height fluid class="text-center">
                                <v-row align="center"
                                    justify="center"
                                    >
                                    <v-col>
                                        <v-card flat>
                                            <v-card-title class="font-weight-bold justify-center">No Farm Found</v-card-title>
                                            <v-card-text>
                                                If you want to add a primary farm please click the button below.
                                            </v-card-text>
                                            <v-card-action class="justify-center">
                                                <v-btn color="primary" depressed>ADD a Primary  Farm</v-btn>
                                            </v-card-action>
                                        </v-card>

                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>
<script>


export default {

    data() {
        return {
            breadcrumbs: [
				{
					text: 'Dashboard',
					disabled: false,
					to: '/',
				},
				{
					text: 'Saved Geo Fence',
					disabled: true,
				},
			],
        }
    },
    methods: {


    }
}

</script>
